// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// @mui material components
import TableRow from "@mui/material/TableRow";

// Kaizen Dashboard base styles
import { Icon, Tooltip } from "@mui/material";
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";
import SoftBadge from "components/SoftBadge";
import SoftInputNumber from "components/SoftInputNumberUpgrade";
import { useEffect, useState } from "react";
import { makeNiceText } from "utils/formatters";
import { getUproColor } from "utils/colors";
import SoftButton from "components/SoftButton";

function TableItem({ material, handleUpdateMaterial, handleRemoveMaterial, tipoAjuste, disabled, disabledOperator }) {
  const { light } = colors;
  const { borderWidth } = borders;

  const [materialData, setMaterialData] = useState({
    ...material,
    cantidad: material?.cantidad || material?.stock?.cantidad || 0,
  });

  const handleChanges = (e) => {
    const { name, value } = e.target;
    setMaterialData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    handleUpdateMaterial(materialData);
  }, [materialData]);
  const [cantidadOriginal, setCantidadOriginal] = useState(null);

  useEffect(() => {
    if (tipoAjuste === "Merma" && cantidadOriginal === null) {
      setCantidadOriginal(materialData?.cantidad);
    }
    if (tipoAjuste !== "Merma") {
      setCantidadOriginal(null);
    }
  }, [tipoAjuste]);
  return (
    <TableRow hover>
      <SoftBox
        component="td"
        p={1}
        textAlign={"center"}
        borderBottom={`${borderWidth[1]} solid ${light.main}`}
      >
        <SoftBox
          display="flex"
          alignItems="center"
          sx={{
            cursor: "pointer",
          }}
        >
          <SoftBox pl={3} mr={2} display="flex">
            <Tooltip title={material.tipo} placement="top">
              <Icon
                sx={{
                  verticalAlign: "middle",
                  cursor: "pointer",
                  color:
                    material.tipo === "Material"
                      ? getUproColor("uproYellow")
                      : material.tipo === "Consumible"
                        ? getUproColor("uproGreen")
                        : getUproColor("uproPink"),
                }}
                fontSize="lg"
              >
                {material.tipo === "Material"
                  ? "category"
                  : material.tipo === "Consumible"
                    ? "recycling"
                    : "layers"}
              </Icon>
            </Tooltip>
          </SoftBox>
        </SoftBox>
      </SoftBox>
      <SoftBox
        component="td"
        p={1}
        textAlign={"center"}
        borderBottom={`${borderWidth[1]} solid ${light.main}`}
      >
        <SoftTypography verticalAlign="middle" variant="caption" color="dark" fontWeight="bold">
          {material?.id}
        </SoftTypography>
      </SoftBox>
      <SoftBox
        component="td"
        p={1}
        textAlign={"center"}
        borderBottom={`${borderWidth[1]} solid ${light.main}`}
      >
        <SoftTypography
          verticalAlign="middle"
          variant="caption"
          color="secondary"
          fontWeight="medium"
        >
          {material?.nombre?.length > 70
            ? makeNiceText(material?.nombre).slice(0, 70) + "..."
            : makeNiceText(material?.nombre)}
        </SoftTypography>
      </SoftBox>
      <SoftBox
        component="td"
        p={1}
        textAlign={"center"}
        borderBottom={`${borderWidth[1]} solid ${light.main}`}
      >
        <SoftTypography
          verticalAlign="middle"
          variant="caption"
          color="secondary"
          fontWeight="medium"
        >
          {material?.categoria ? makeNiceText(material?.categoria) : "Sin rubro"}
        </SoftTypography>
      </SoftBox>
      {!disabled && (
        <SoftBox
          component="td"
          p={1}
          textAlign={"center"}
          borderBottom={`${borderWidth[1]} solid ${light.main}`}
        >
          <SoftBox>
            <SoftTypography
              verticalAlign="middle"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {`${material?.stock?.cantidad / material?.tipoUnidad?.multiplicador || 0} ${material?.tipoUnidad?.abreviatura
                }`}
            </SoftTypography>
          </SoftBox>
        </SoftBox>
      )}
      {!disabled && (
        <SoftBox
          component="td"
          textAlign={"center"}
          borderBottom={`${borderWidth[1]} solid ${light.main}`}
        >
          <SoftBox>
            <Tooltip title={materialData?.operation == "add" ? "Sumar valor" : "Restar valor"} placement="top">
              <SoftButton
                color={materialData?.operation == "add" ? "success" : "error"}
                onClick={() => {
                  setMaterialData((prevState) => ({
                    ...prevState,
                    operation: materialData?.operation == "add" ? "remove" : "add",
                  }))
                }}
                variant="outlined"
                circular
                disabled={disabledOperator}
              >
                {materialData?.operation == "add" ? "Sumar" : "Restar"}
              </SoftButton>
            </Tooltip>
          </SoftBox>
        </SoftBox>
      )}
      {disabled && (
        <SoftBox
          component="td"
          p={1}
          textAlign={"center"}
          borderBottom={`${borderWidth[1]} solid ${light.main}`}
        >
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftBadge
              color={
                material?.cantidad > 0 ? "success" : material?.cantidad < 0 ? "error" : "warning"
              }
              size="xs"
              badgeContent={
                <SoftTypography
                  verticalAlign="text-top"
                  variant="caption"
                  color="white"
                  fontWeight="medium"
                >
                  {`${material.cantidad > 0 ? "+" : ""}${material.cantidad / material.tipoUnidad.multiplicador
                    } ${material.tipoUnidad.abreviatura}`}
                </SoftTypography>
              }
              container
            />
          </SoftBox>
        </SoftBox>
      )}
      {!disabled && (
        <SoftBox
          component="td"
          p={1}
          textAlign={"center"}
          borderBottom={`${borderWidth[1]} solid ${light.main}`}
        >
          <SoftBox>
            <SoftInputNumber
              placeholder="Cantidad"
              name="cantidad"
              value={0}
              error={
                tipoAjuste === "Merma" || tipoAjuste === "Devolucion Proveedor" || materialData?.operation == "remove"
                  ? materialData?.cantidad < 0 || materialData?.cantidad > material?.stock?.cantidad
                  : materialData?.cantidad < 0
              }
              onChange={(e) => {
                let inputCantidad = parseFloat(e.target.value) || 0; // Asegurar número válido

                setMaterialData((prevState) => ({
                  ...prevState,
                  cantidad: inputCantidad * material?.tipoUnidad?.multiplicador
                }));
              }}
              icon={{
                component: (
                  <SoftBox
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <SoftTypography variant="h6">
                      {materialData?.tipoUnidad?.abreviatura}
                    </SoftTypography>
                  </SoftBox>
                ),
                direction: "right",
              }}
            />
          </SoftBox>
        </SoftBox>
      )}
      {!disabled && (
        <SoftBox
          component="td"
          p={1}
          textAlign={"center"}
          borderBottom={`${borderWidth[1]} solid ${light.main}`}
        >
          <SoftBox
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftBox pl={3} mr={2} display="flex">
              <Tooltip title="Quitar de la lista" placement="top">
                <Icon
                  sx={{
                    verticalAlign: "middle",
                    cursor: "pointer",
                  }}
                  color="error"
                  fontSize="lg"
                  onClick={() => handleRemoveMaterial(material)}
                >
                  delete
                </Icon>
              </Tooltip>
            </SoftBox>
          </SoftBox>
        </SoftBox>
      )}
    </TableRow>
  );
}

// Typechecking props of the TableItem
TableItem.propTypes = {
  material: PropTypes.object.isRequired,
  handleUpdateMaterial: PropTypes.func.isRequired,
  handleRemoveMaterial: PropTypes.func.isRequired,
  tipoAjuste: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  disabledOperator: PropTypes.bool,
};

export default TableItem;
